import React from 'react';

import Show from 'components/Show';
import Editor from 'components/Editor';
import { Input } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import Option from 'containers/Shared/Exams/Profile/Review/View/Option';
import Upload from 'containers/Shared/Exams/Profile/Review/View/Upload';

import { useExamReviewStore } from 'store/exam/useExamReviewStore';

const Question = ({ idx, type, question }) => {
	// Use exam's student store
	const slug = useExamReviewStore(state => state.exam.slug);
	const task = useExamReviewStore(state => state.tasks.find(t => t.id === question.taskId));
	const onChangeAnswer = useExamReviewStore(state => state.onChangeAnswer);

	const onChange = (change) => {
		onChangeAnswer(question.id, change);
	};

	return (
		<div key={question.id} className="space-y-2">
			<div className="pb-2 flex items-center">
				<Title
					title={`${idx + 1}. jautājums`}
					className="flex-1"
				/>
				
				<div className="flex items-center justify-end space-x-1">
					<Input
						name="score"
						className=""
						inputClassName="w-11 px-0 text-center"
						value={question.score}
						onChange={onChange}
					/>
					<div>/</div>
					<div>{task.points}</div>
				</div>
			</div>

			{/* Question's description */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				type="spellcheck"
				value={question?.content}
				spellcheck={{
					mode: 'review',
					words: question?.words
				}}
			/>

			{/* Question's answer */}
			<Show if={['multiple', 'essay'].includes(type)}>
				<Title title="Atbilde" />

				<div className="text-base text-neutral-800 dark:text-white whitespace-pre-wrap">
					{question?.answer}
				</div>
			</Show>
			
			{/* Connect answer */}
			<Show if={type === 'connect'}>
				<Title title="Atbilde" />
				
				{/* Question's answer */}
				<Editor
					readOnly
					path="exams"
					folder={slug}
					value={question?.answer}
				/>

				<Title title="Pareizā atbilde" />
				
				{/* Question's correct answer */}
				<Editor
					readOnly
					path="exams"
					folder={slug}
					value={question?.correctAnswer}
				/>
			</Show>

			{/* Question's option list */}
			<Show if={type === 'quiz'}>
				<div className="mt-4 flex flex-col gap-4">
					{question.options?.map(option =>
						<Option key={option.id} questionId={question.id} option={option} />
					)}
				</div>
			</Show>

			{/* Question's file list */}
			<Show if={type === 'upload'}>
				<Title title="Atbilde" />
				
				<Upload files={question?.files} />
			</Show>
		</div>
	);
};

export default Question;